import { FC } from "react";
import { AdminAccountResDto } from "service/api/estabrookSchemas";
import WarningConfirmDialog from "./WarningConfirmDialog";

export interface MemberDeleteConfirmDialogProps {
  member: AdminAccountResDto | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const MemberDeleteConfirmDialog: FC<MemberDeleteConfirmDialogProps> = ({
  member,
  isSubmitting,
  onConfirm,
  onCancel,
}) => (
  <WarningConfirmDialog
    open={Boolean(member)}
    title="Delete Member"
    description={`Are you sure you want to delete ${member?.firstName} ${member?.lastName}?`}
    warningText="They will be logged out immediately and will no longer be a part of an organization."
    confirmLabel="Delete"
    isSubmitting={isSubmitting}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmTestId="confirm-delete-member"
    cancelTestId="cancel-delete-member"
  />
);

export default MemberDeleteConfirmDialog;
